import { CloudUpload } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const CloudUploadIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <CloudUpload width={size} height={size} color={color} {...rest} />;

CloudUploadIcon.displayName = 'CloudUploadIcon';

export default CloudUploadIcon;
